export default {
  addImageOptional: 'Add Image (optional)',
  dropdown: {
    placeholder: 'select a value...'
  },
  venueDropdown: {
    allVenues: 'All Venues'
  },
  file: {
    chooseFile: 'Choose File'
  }
};
